export default __webpack_public_path__ + "static/kb_3_8-edae699c79200d2484bf86024ffb35ea.jpg";